import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import generalConfig from '@/config/general';
import ModalHoc from '@/components/ModalHoc';
import SectionHeader from '@/components/headers/Section';
import ShareGrid from '@/components/Editor/share/Grid';
import ShareTile from '@/components/Editor/share/Tile';
import useShareOptions from '@/components/Editor/hooks/useShareOptions';
import modalStyles from '@/components/ModalHoc/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_579_3054)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.00001 2.33329C5.31811 2.33329 2.33334 5.31806 2.33334 8.99996C2.33334 12.6819 5.31811 15.6666 9.00001 15.6666C12.6819 15.6666 15.6667 12.6819 15.6667 8.99996C15.6667 5.31806 12.6819 2.33329 9.00001 2.33329ZM0.666672 8.99996C0.666672 4.39759 4.39763 0.666626 9.00001 0.666626C13.6024 0.666626 17.3333 4.39759 17.3333 8.99996C17.3333 13.6023 13.6024 17.3333 9.00001 17.3333C4.39763 17.3333 0.666672 13.6023 0.666672 8.99996Z",
        fill: "#515466"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9 4.83337C8.53977 4.83337 8.16667 5.20647 8.16667 5.66671C8.16667 6.12694 8.53977 6.50004 9 6.50004C9.46024 6.50004 9.83334 6.12694 9.83334 5.66671C9.83334 5.20647 9.46024 4.83337 9 4.83337Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.83334 9.00004C9.83334 8.5398 9.46024 8.16671 9 8.16671C8.53977 8.16671 8.16667 8.5398 8.16667 9.00004V12.3334C8.16667 12.7936 8.53977 13.1667 9 13.1667C9.46024 13.1667 9.83334 12.7936 9.83334 12.3334V9.00004Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_579_3054",
        children: /*#__PURE__*/_jsx("rect", {
          width: "17",
          height: "17",
          fill: "white",
          transform: "translate(0.5 0.5)"
        })
      })
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExportIcon = function ExportIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#515466",
      fillRule: "evenodd",
      d: "M0 10.881v-2.88a.889.889 0 1 1 1.778 0v2.844c0 .76 0 1.278.033 1.679.032.39.09.589.16.728.171.334.443.606.777.776.14.071.339.13.728.16.4.034.918.034 1.68.034h5.688c.762 0 1.28 0 1.68-.033.39-.032.589-.09.728-.16.334-.17.606-.443.776-.777.071-.14.129-.339.16-.728.034-.4.034-.918.034-1.68V8A.889.889 0 1 1 16 8v2.881c0 .716 0 1.306-.04 1.787-.04.5-.128.96-.348 1.39a3.556 3.556 0 0 1-1.553 1.555c-.432.22-.891.307-1.39.348-.482.04-1.072.04-1.788.04H5.12c-.716 0-1.306 0-1.787-.04-.5-.041-.96-.129-1.39-.348a3.556 3.556 0 0 1-1.554-1.554c-.22-.432-.308-.891-.349-1.39C0 12.186 0 11.596 0 10.88Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#515466",
      d: "M5.962 4.184a.889.889 0 1 1-1.257-1.257L7.37.26a.889.889 0 0 1 1.257 0l2.667 2.667a.889.889 0 0 1-1.257 1.257l-1.15-1.15v7.633a.889.889 0 0 1-1.777 0V3.035l-1.15 1.15Z"
    })]
  }));
};

ExportIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};

var UniversalCodeIcon = function UniversalCodeIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: ".65",
      d: "M1 4.8c0-1.68 0-2.52.327-3.162A3 3 0 0 1 2.638.327C3.28 0 4.12 0 5.8 0h5.875c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l2.126 2.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963V15.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C14.72 20 13.88 20 12.2 20H5.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C1 17.72 1 16.88 1 15.2V4.8Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M12.707 11.293a1 1 0 0 1 0 1.414l-1 1a1 1 0 0 1-1.414-1.414l.293-.293-.293-.293a1 1 0 1 1 1.414-1.414l1 1ZM5.293 11.293a1 1 0 0 0 0 1.414l1 1a1 1 0 0 0 1.414-1.414L7.414 12l.293-.293a1 1 0 1 0-1.414-1.414l-1 1ZM11 1.414a1.414 1.414 0 0 1 2.414-1l3.172 3.172a1.414 1.414 0 0 1-1 2.414H13a2 2 0 0 1-2-2V1.414Z"
    })]
  }));
};

UniversalCodeIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "20",
  fill: "none"
}; // const PREFIX = 'components: Editor: modals: Share:';

const ShareModal = _ref => {
  let {
    isLoading = false,
    subText = 'Share Widget',
    onCopySnippet
  } = _ref;
  const {
    onOpenCalculatorBlocksProfile
  } = useShareOptions();
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      Icon: /*#__PURE__*/_jsx(ExportIcon, {}),
      subText: subText,
      className: clsx('-ml-none', '-mr-none'),
      children: ["Get a ", /*#__PURE__*/_jsx("strong", {
        children: "Universal Code"
      }), " ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("span", {
        children: ["or connect a ", /*#__PURE__*/_jsx("strong", {
          children: "Platform"
        })]
      })]
    }), /*#__PURE__*/_jsxs(ShareGrid, {
      className: "-mb-xlarge",
      children: [/*#__PURE__*/_jsx(ShareTile, {
        src: "/img/share/wordpress-tile.webp",
        alt: "Wordpress Logo over blue background",
        heading: "Gutenberg Block",
        primary: "Install Plugin",
        primaryTooltip: "Redirect to the Calculator Blocks Wordpress plugin page.",
        secondary: "Learn More",
        SecondaryIcon: /*#__PURE__*/_jsx(InfoIcon, {}),
        secondaryTooltip: `This plugin allows you to manage your ${generalConfig.productName} widgets directly as a Wordpress Gutenberg block.`,
        onClick: onOpenCalculatorBlocksProfile
      }), /*#__PURE__*/_jsx(ShareTile, {
        src: "/img/share/universal-tile.webp",
        alt: `${generalConfig.productName} embed code snippet overlayed on blue background`,
        heading: "Universal Code",
        primary: "Get Code",
        primaryTooltip: "Copy the univeral code snippet to your clipboard.",
        PrimaryIcon: /*#__PURE__*/_jsx(UniversalCodeIcon, {}),
        primaryDisabled: isLoading,
        secondary: "Learn More",
        SecondaryIcon: /*#__PURE__*/_jsx(InfoIcon, {}),
        secondaryTooltip: "Once you copy the code snippet to your clipboard you may place it anywhere that HTML code can applied.",
        onClick: onCopySnippet
      })]
    })]
  });
};

export default ModalHoc(ShareModal, {
  modalClass: modalStyles['container--big'],
  overlayclass: modalStyles['overlay--high'],
  hasCloseButton: true
});